module.exports = __webpack_public_path__ + "img/13.2ff70146.jpg";